<div class="container">
    <div class="title-area">
        <div class="title">
            <div class="caption-0">{{'dashboard.column_settings' | stringLiterals}}</div>
            <label class="title-label">{{'dashboard.column_title' | stringLiterals}} <span
                    class="required-field">*</span></label>
            <div class="title-input tam-input-tip">
                <input type="text" class="tam-input"
                    [ngClass]="{'tam-input-bad':!config.title.trim() || config.title.trim().length>32}"
                    [(ngModel)]="config.title" [placeholder]="config.name" />
                <div class="tam-form-help" *ngIf="!config.title.trim()">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help" *ngIf="config.title.trim().length > 32">
                    {{'dashboard.column_title_exceeds_the_maximum_of_32_characters_allowed' | stringLiterals}}
                </div>
                <label class="title-field">{{'dashboard.database_field' | stringLiterals}}
                    <span>{{config.name}}</span></label>
            </div>
        </div>
        <div class="show-hide">
            <div>{{'dashboard.show_column' | stringLiterals}}</div>
            <kendo-switch [checked]="!config.hidden" onLabel="Yes" offLabel="No"
                (valueChange)="onShowColumnChange($event)"></kendo-switch>
        </div>
    </div>
    <div class="detail-area">
        <div [ngSwitch]="config.columnType">
            <div *ngSwitchCase="'entityColumn'">
                <tile-entity-column-detail [config]="config" [wholeConfig]="wholeConfig" [briefConfig]="briefConfig">
                </tile-entity-column-detail>
            </div>
            <div *ngSwitchCase="'contactColumn'">
                <tile-contact-column-detail [config]="config" [wholeConfig]="wholeConfig" [briefConfig]="briefConfig">
                </tile-contact-column-detail>
            </div>
            <div *ngSwitchCase="'entryColumn'">
                <tile-entry-column-detail [config]="config" [wholeConfig]="wholeConfig" [briefConfig]="briefConfig">
                </tile-entry-column-detail>
            </div>
            <div *ngSwitchCase="'Relationship'">
                <tile-relationship-column-detail [config]="config" [wholeConfig]="wholeConfig">
                </tile-relationship-column-detail>
            </div>
            <div *ngSwitchCase="'MDL'">
                <tile-mdl-column-detail [config]="config" [wholeConfig]="wholeConfig" [briefConfig]="briefConfig">
                </tile-mdl-column-detail>
            </div>
            <div *ngSwitchCase="'Formula'">
                <tile-formula-column-detail [config]="config" [wholeConfig]="wholeConfig" [briefConfig]="briefConfig">
                </tile-formula-column-detail>
            </div>
        </div>
    </div>
    <div class="alignment">
        <div class="row-title">{{'general.alignment' | stringLiterals}}</div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="alignmentList"
                [textField]="'value'" [valueField]="'id'" [value]="selectedAlignment"
                (valueChange)="onAlignmentChange($event)">
            </kendo-dropdownlist>
        </div>
    </div>
    <div class="format-area">
        <tile-conditional-formatting [config]="config" [fields]="wholeConfig.columns">
        </tile-conditional-formatting>
    </div>
</div>